// extracted by mini-css-extract-plugin
export default {"r_l":"_572660ae52 c60ff4e27e","t":"c35400d2b2"};